import en_us from './en_us'
import zh_cn from './zh_cn'
import zh_tw from './zh_tw'
import ja_jp from './ja_jp'
import ko_kr from './ko_kr'
import tr_tr from './tr_tr'
export default {
  en_us: en_us,
  zh_tw: zh_tw,
  zh_cn: zh_cn,
  tr_tr: tr_tr,
//   ja_jp: ja_jp,
//   ko_kr: ko_kr,
}
